import {holderIdentity} from "./property-format";
import type {ProspectDetail} from '../../api';
import {buildDocumentedConnections,documentedConnectionsNote,familyMentions} from './documented-connections';

export function DocumentedConnections({detail}:{detail:ProspectDetail}) {
  const people=buildDocumentedConnections(detail.immobili,detail.matchedCf,detail.nome);
  const mentions=familyMentions(detail.contenuto);
  if(!people.length && !mentions.length)return null;
  return <section className="col gap-12">
    <div className="k" style={{fontWeight:600}}>Collegamenti documentati</div>
    <p className="muted" style={{margin:0,fontSize:12}}>{documentedConnectionsNote}</p>
    {people.length>0 && <div className="col gap-8">
      <div className="k">Cointestatari degli immobili della scheda · {people.length}</div>
      {people.map(person=><details key={person.cf ?? person.nome} className="preview-box" style={{padding:12}}>
        <summary style={{cursor:'pointer'}}>{holderIdentity(person.nome).name} · {person.immobili.length} {person.immobili.length===1?'immobile condiviso':'immobili condivisi'}</summary>
        <div className="col gap-8 mt-8">
          {person.immobili.map((im,index)=><div key={`${im.riferimento}-${index}`}>
            <div>{im.indirizzo}</div>
            <div className="muted" style={{fontSize:11}}>{im.riferimento}</div>
            <div style={{fontSize:12}}>{im.diritto} · quota {im.quota}</div>
          </div>)}
          <div className="muted" style={{fontSize:11}}>Fonte: visura del defunto. Non cerchiamo gli immobili intestati solo ai familiari.</div>
        </div>
      </details>)}
    </div>}
    {mentions.length>0 && <div className="col gap-6">
      <div className="k">Familiari menzionati nel necrologio</div>
      {mentions.map(fragment=><blockquote key={fragment} style={{margin:0,fontSize:12}}>{fragment}</blockquote>)}
      <div className="muted" style={{fontSize:11}}>Citazione della fonte. I cognomi ricavati stanno nella lista Persone nel necrologio.</div>
      {/^https?:\/\//i.test(detail.link ?? '') && <a href={detail.link!} target="_blank" rel="noopener noreferrer">Leggi il necrologio originale ↗</a>}
    </div>}
  </section>;
}
